<apx-chart
  *ngIf="chartData"
  class="flex-auto w-full h-full"
  [chart]="chartData.chart"
  [colors]="chartData.colors"
  [dataLabels]="chartData.dataLabels"
  [grid]="chartData.grid"
  [labels]="chartData.labels"
  [legend]="chartData.legend"
  [plotOptions]="chartData.plotOptions"
  [series]="chartData.series"
  [states]="chartData.states"
  [stroke]="chartData.stroke"
  [tooltip]="chartData.tooltip"
  [responsive]="chartData.responsive"
  [xaxis]="chartData.xaxis"
  [fill]="chartData.fill"
  [yaxis]="chartData.yaxis"
></apx-chart>
